import { render, staticRenderFns } from "./GCreateNewCustomer.vue?vue&type=template&id=6bdb4708&"
import script from "./GCreateNewCustomer.vue?vue&type=script&lang=ts&"
export * from "./GCreateNewCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./GCreateNewCustomer.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports